<template>
  <div id="contenedor-contrato-actualizar-estatus">
    <template v-if="mostrarActualizarEstatus">
      <v-chip v-if="estatus.color" :color="estatus.color">
        <span :style="estatus.esTextoClaro ? 'color: white' : ''">{{estatus.nombre}}</span>
        <v-btn
          @click="mostrarActualizarEstatus = !mostrarActualizarEstatus"
          icon
        >
          <v-icon :color="estatus.esTextoClaro ? 'white' : ''">
            mdi-pencil
          </v-icon>
        </v-btn>
      </v-chip>
      <custom-button
        v-else
        @click="mostrarActualizarEstatus = !mostrarActualizarEstatus"
        tipo="formAceptar"
        label="Agregar Estatus de Contrato"
        iconText="mdi-pencil"
      >
      </custom-button>
    </template>
    <template v-else>
      <custom-auto-complete
        v-model="contratoEstatus"
        label="Estatus"
        :items="getContratosEstatus"
        item-text="nombre"
        item-value="id"
        dense
        @change="cambiarEstatus"
      >
      </custom-auto-complete>
      <custom-button
        @click="mostrarActualizarEstatus = !mostrarActualizarEstatus"
        tipo="formCancelar"
        label="Cancelar"
      >
      </custom-button>
    </template>
  </div>
</template>

<script>
import mixContrato from './mixContrato';
import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ContratoActualizarEstatus',
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    estatus: {
      type: Object,
      required: false,
    },
    idContratoEstatus: {
      type: String,
      required: false,
    },
  },
  mixins: [mixContrato],
  components: {
    CustomAutoComplete,
    CustomButton,
  },
  data() {
    return {
      mostrarActualizarEstatus: true,
      contratoEstatus: this.idContratoEstatus,
    };
  },
};
</script>

<style lang="scss">
</style>
